module.exports = __webpack_public_path__ + "static/media/star_green.0cb68e4a.svg";